import axios from "axios";

const API_URL = process.env.REACT_APP_API_ENDPOINT
  ? process.env.REACT_APP_API_ENDPOINT.replace(/\/+$/, "") + "/"
  : "";

/**
 * Compare market data from two MongoDB sources
 * @param {Object} params - Comparison parameters
 * @returns {Promise} Axios response with comparison result
 */
export const compareTwoSources = async (params) => {
  try {
    const requestParams = {
      source1Host: params.source1Host,
      source1Date: params.source1Date,
      source1Time: params.source1Time,
      source1TradeType: params.source1TradeType,
      source2Host: params.source2Host,
      source2Date: params.source2Date,
      source2Time: params.source2Time,
      source2TradeType: params.source2TradeType,
    };
    
    // Add optional parameters only if they are provided
    if (params.source1Username) {
      requestParams.source1Username = params.source1Username;
    }
    if (params.source1Password) {
      requestParams.source1Password = params.source1Password;
    }
    if (params.source2Username) {
      requestParams.source2Username = params.source2Username;
    }
    if (params.source2Password) {
      requestParams.source2Password = params.source2Password;
    }
    if (params.symbol) {
      requestParams.symbol = params.symbol;
    }
    
    const response = await axios.get(`${API_URL}api/market-data/compare-two-sources`, {
      params: requestParams,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Compare market data (live vs paper) from same MongoDB source
 * @param {Object} params - Comparison parameters
 * @returns {Promise} Axios response with comparison result
 */
export const compareMarketData = async (params) => {
  try {
    const response = await axios.get(`${API_URL}api/market-data/compare`, {
      params: {
        date: params.date,
        onlyTime: params.onlyTime,
        symbol: params.symbol || null,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Compare IndexAnalysisInfo from two MongoDB sources
 * @param {Object} params - Comparison parameters
 * @returns {Promise} Axios response with comparison result
 */
export const compareIndexAnalysisInfo = async (params) => {
  try {
    const response = await axios.get(`${API_URL}api/index-analysis/compare-two-sources`, {
      params: {
        source1Host: params.source1Host,
        source1Symbol: params.source1Symbol,
        source1Timestamp: params.source1Timestamp,
        source2Host: params.source2Host,
        source2Symbol: params.source2Symbol,
        source2Timestamp: params.source2Timestamp,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

